module.exports = __webpack_public_path__ + "img/mother_and_daughter.ab9138b9.jpg";